module.exports = __webpack_public_path__ + "media/configurations/O-X-3d6c043c.png";